<app-access-item [small]="small()">
  @if (icon()) {
    <app-access-item-icon>
      <app-gallery-settings-icon [src]="icon()"> </app-gallery-settings-icon>
    </app-access-item-icon>
  }
  <app-access-item-header>
    <div>{{ title() }}</div>
  </app-access-item-header>

  <app-access-item-cta>
    <app-context-menu [options]="{ width: '272px', noSpacing: true }" #colorMenu>
      <div
        class="color-selector"
        [class.allow-opacity]="allowOpacity()"
        [style.--selected-color]="color()"
        contextButton
      ></div>
      <div contextContent>
        @if (colorMenu.isOpen()) {
          @if (allowOpacity()) {
            <app-color-picker
              [color]="color()"
              [allowOpacity]="allowOpacity()"
              (colorChange)="colorChange.emit($event)"
            >
            </app-color-picker>
          } @else {
            <app-color-selector
              [currentColor]="color()"
              [allowOpacity]="allowOpacity()"
              (currentColorChange)="colorChange.emit($event)"
              [gallery]="gallery()"
            >
            </app-color-selector>
          }
        }
      </div>
    </app-context-menu>
  </app-access-item-cta>
</app-access-item>
